import{createCommand as I}from"lexical";var _=I("INSERT_RELATIONSHIP_WITH_DRAWER_COMMAND");export{_ as a};
//# sourceMappingURL=chunk-DBWINSQN.js.map
